@if(isStepReady && viewModel && rootViewModel){
  <div class="step-template">
    <nts-expandable [title]="'Categoria e Tipo di Spesa'" [isCollapsed]="false" [disableToggle]="true">
      {{'ExpenseSelectionStep_Title'| NTSTranslate}}
      <div class="state-container" *ngIf="viewModel.showCurrentState">
        <div class="state-box">
          <div class="state-color"
            [style.backgroundColor]="viewModel.expenseStateMapper.getColorByExpenseStateType(viewModel.expenseState.value)">
            <div class="state-icon">
              <svg-icon [key]="viewModel.expenseStateMapper.getIconByExpenseStateType(viewModel.expenseState.value)">
              </svg-icon>
            </div>
          </div>
          <div class="state-label">{{viewModel.expenseState.formattedValue}}</div>
        </div>
      </div>

      <div class="element-list">
        <nts-expense-classification-box *ngFor="let expenseClassification of expenseClassificationList;"
          [editable]="viewModel.expenseClassification.isEnabled"
          [selected]="expenseClassification === viewModel.expenseClassification.value" [item]="expenseClassification"
          [prefillColor]="expenseClassification === viewModel.expenseClassification.value ? classificationPrefillColor : null"
          (onClicked)="selectExpenseClassification($event)" [newLabel]="viewModel.newLabels() | async">
        </nts-expense-classification-box>

        <div *ngIf="!expenseClassificationList.length" class="empty-message-container">
          <div class="empty-logo">
            <svg-icon [fontSize]="'50px'" [key]="'warning-circle-outline'"></svg-icon>
          </div>
          <div class="empty-message">
            {{'ExpenseSelectionStep_NoExpenseClassificationFoundMessage'| NTSTranslate}}
          </div>
        </div>

      </div>

      <nts-external-list #expandableChild
        [isDisabled]="this.receiptStepsService.isReadOnly$ | async"
        [labelPosition]="'top'" [externalPropertyViewModel]="rootViewModel.params.expenseData.extendedExpenseTypeRef"
        [code]="rootViewModel.params.expenseData.extendedExpenseTypeRef.id" [appendTo]="'body'"
        [decodeProperties]="['description','classification']">
      </nts-external-list>

      <nts-labelled-text-box #expandableChild [propertyViewModel]="rootViewModel.params.expenseData?.description"
        [labelPosition]="'top'">
      </nts-labelled-text-box>
    </nts-expandable>



    <!-- 'ExpenseDataStep_Expandable_Main' | NTSTranslate -->
    <nts-expandable [title]="'Dettagli Pagamento e Fornitore'" [isCollapsed]="false" [promotedFields]="">

      <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
        [propertyViewModel]="rootViewModel.params.expenseData.expenseDate">
      </nts-labelled-text-box>

      <nts-spacer-box
        *ngIf="!isMobileView()">
      </nts-spacer-box>

      <sdt-external-list [labelPosition]="'top'" #expandableChild
        [externalPropertyViewModel]="rootViewModel.params.expenseData.currencyRef"
        [code]="rootViewModel.params.expenseData.currencyRef.id" [appendTo]="'body'"
        [numericPropertyViewModel]="rootViewModel.params.expenseData.expenseTotalAmount"
        [isVisibleNumericPropertyViewModel]="rootViewModel.params.expenseData.expenseClassificationEnum.MileageRefound !== rootViewModel.params.expenseData.currentExpenseClassificationType">
      </sdt-external-list>

      <nts-spacer-box
        *ngIf="!isMobileView() && rootViewModel.params.expenseData.currencyRef?.id.value && rootViewModel.params.expenseData.currencyRef?.isDefault.value">
      </nts-spacer-box>

      <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
        *ngIf="rootViewModel.params.expenseData.currencyRef?.id.value && !rootViewModel.params.expenseData.currencyRef?.isDefault.value"
        [propertyViewModel]="rootViewModel.params.expenseData.exchangeRateQuote">
      </nts-labelled-text-box>

      <nts-external-list [labelPosition]="'top'" #expandableChild
        *ngIf="rootViewModel.params.paymentData.currentExpenseClassificationType !== rootViewModel.params.paymentData.expenseClassificationEnum.MileageRefound && rootViewModel.params.paymentData.isEnabled"
        [externalPropertyViewModel]="rootViewModel.params.paymentData.extendedPaymentTypeRef" [appendTo]="'body'"
        [code]="rootViewModel.params.paymentData.extendedPaymentTypeRef.id"
        [decodeDescription]="rootViewModel.params.paymentData.extendedPaymentTypeRef.description">
      </nts-external-list>

      <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
        [propertyViewModel]="rootViewModel.params.paymentData.paymentTypeDescription"
        *ngIf="rootViewModel.params.paymentData.currentExpenseClassificationType !== rootViewModel.params.paymentData.expenseClassificationEnum.MileageRefound && !rootViewModel.params.paymentData.isEnabled">
      </nts-labelled-text-box>



      <div class="supplier-container">
        <div class="supplier-box" *ngIf="showSupplierRefBox()">
          <nts-decode-text-box [labelPosition]="'top'" #expandableChild
            [externalPropertyViewModel]="rootViewModel.params.paymentData.supplierRef"
            [appendTo]="'body'"
            [code]="rootViewModel.params.paymentData.supplierRef.id">
          </nts-decode-text-box>
          <nts-text-button *ngIf="hasSupplierRef()" [icon]="'trash'"
            (onClicked)="deleteSupplierRef()">
          </nts-text-button>
          <nts-text-button *ngIf="canAddManualSupplier()" [icon]="'plus'" (onClicked)="addSupplierNotSaved()">
          </nts-text-button>
        </div>
        <div class="supplier-box" *ngIf="showManualSupplierBox()">
          <nts-labelled-text-box [isDisabled]="true" [labelPosition]="'top'" #expandableChild
            [propertyViewModel]="rootViewModel.params.paymentData.businessName">
          </nts-labelled-text-box>
          <nts-labelled-text-box [isDisabled]="true" [labelPosition]="'top'" #expandableChild
            [propertyViewModel]="rootViewModel.params.paymentData.vatNumber">
          </nts-labelled-text-box>
          <nts-text-button *ngIf="canAddManualSupplier()" [icon]="'plus'" (onClicked)="addSupplierNotSaved()">
          </nts-text-button>
          <nts-text-button *ngIf="!canAddManualSupplier()" [icon]="'trash'" (onClicked)="deleteManualSupplier()">
          </nts-text-button>
        </div>
      </div>

    </nts-expandable>



    @if((rootViewModel.params.expenseData.commissionRef.isVisible$ | async) || (rootViewModel.params.expenseData.customerRef.isVisible$ | async) || (rootViewModel.params.expenseData.leadRef.isVisible$ | async)) {

      <nts-expandable [title]="'ReceiptLongOp_ExpenseData_External_Expandable' | NTSTranslate" [isCollapsed]="false">

        @if(rootViewModel.params.expenseData.commissionRef.isVisible$ | async){
          <nts-decode-text-box [labelPosition]="'top'" #expandableChild
            [appendTo]="'body'"
            [externalPropertyViewModel]="rootViewModel.params.expenseData.commissionRef">
          </nts-decode-text-box>
        }

        @if(rootViewModel.params.expenseData.customerRef.isVisible$ | async){
          <nts-decode-text-box [labelPosition]="'top'" #expandableChild
            [appendTo]="'body'"
            [externalPropertyViewModel]="rootViewModel.params.expenseData.customerRef">
          </nts-decode-text-box>
        }

        @if(rootViewModel.params.expenseData.leadRef.isVisible$ | async){
          <nts-decode-text-box [labelPosition]="'top'" #expandableChild
            [appendTo]="'body'"
            [externalPropertyViewModel]="rootViewModel.params.expenseData.leadRef">
          </nts-decode-text-box>
        }

      </nts-expandable>

    }


    <nts-expandable [title]="'ExpenseSelectionStep_NoteTitle' | NTSTranslate" [isCollapsed]="false">
      <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
        [propertyViewModel]="rootViewModel.params.expenseData.note" [fullColumn]="true" [multiline]="true">
      </nts-labelled-text-box>
    </nts-expandable>

    <nts-expandable [title]="'ExpenseSelectionStep_AttachmentsTitle' | NTSTranslate" [isCollapsed]="false">
      <div class="custom-component full-column">
        <div class="main-container full-width">
          <div class="edit-container">
            <nts-multiple-file-upload
              [fileFilterCallBack]="isAdditionalFile.bind(this)"
              [disableMoveFile]="true"
              [editable]="rootViewModel.params.expenseData.files.isEnabled"
              [isRemoteUploadEnabled]="rootViewModel.params.expenseModelData.isRemoteUpload"
              [moveDownCallBack]="rootViewModel.params.expenseData.files.moveDown.bind(rootViewModel.params.expenseData.files)"
              [moveUpCallBack]="rootViewModel.params.expenseData.files.moveUp.bind(rootViewModel.params.expenseData.files)"
              [files]="rootViewModel.params.expenseData.files"
              [removeCallBack]="rootViewModel.params.expenseData.files.removeFile.bind(rootViewModel.params.expenseData.files)"
              [viewFileCallBack]="viewExpenseFile.bind(this)"
              [addCallBack]="rootViewModel.params.expenseData.files.addNewItem.bind(rootViewModel.params.expenseData.files)"
              [uploadCallBack]="orchestratorViewModel.uploadExpenseFile.bind(orchestratorViewModel)"
              (filesChanged)="fileUploadValidation()">
            </nts-multiple-file-upload>
          </div>
        </div>
      </div>

    </nts-expandable>


    <nts-fullscreen-preview [showNextPreviousButtons]="true"
      (askNextImage)="viewModel.showFullScreenNextImage()"
      (askPreviousImage)="viewModel.showFullScreenPreviousImage()" [inIframe]="inIframe" [show]="true"
      [(imageSrc)]="viewModel.currentImageModalSrc" [(imageBlob)]="viewModel.currentImageModalBlob"
      [(imageName)]="viewModel.currentImageModalName">
    </nts-fullscreen-preview>


  </div>
}
